import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { filter, find, isEmpty, map, toLower, toUpper, uniqueId } from 'lodash';
import { Select } from 'antd';

import './country-selector.scss';
import countries from './countries.json';

const { Option } = Select;

interface CountrySelectorProps {
  label?: string;
  name?: string;
  value?: string;
  preferredCountries?: string[];
  placeholder?: string;
  isRequired?: boolean;
  isReadonly?: boolean;
  isError?: boolean;
  onChange?: (value: string | undefined) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({
  label,
  value='',
  preferredCountries=['MY','SG','ID','TH'],
  placeholder,
  isRequired,
  isReadonly,
  isError,
  onChange,
}) => {
  const countryID=uniqueId("country-selector--dropdown-container");
  const filteredCountries = [
    ...map(preferredCountries, preferredCountry => {
      return find(countries, country => country.code === toUpper(preferredCountry))
    }),
    ...filter(countries, country => {
      return preferredCountries.indexOf(toUpper(country.code));
    })
  ]

  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (!isEmpty(value)) { setSelected(value); }
  }, [value])

  return (
    <div className="country-selector">
      {label &&
        <label
          aria-label={label}
          aria-required={isRequired}
          className={classNames('inp-label', {
            'inp-label--required': isRequired,
            'inp-label--error': isError
          })}
        >
          {label}
        </label>
      }

      <React.Fragment>
        <Select
          className={classNames({ 'inp--disabled': isReadonly, 'inp--error': isError })}
          disabled={isReadonly}
          dropdownClassName="country-selector--dropdown"
          dropdownMatchSelectWidth={false}
          showSearch={true}
          placeholder={placeholder}
          onSelect={onChange}
          value={selected}
          filterOption={(input, option) => {
            return option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
          getPopupContainer={() =>
            document.getElementById(countryID)!
          }
        >
          {map(filteredCountries, (country: { name: string, code: string }, index) => {
            return (
              <Option key={index} value={country.code}>
                {country.name}
              </Option>
            )
          })}
        </Select>

        <div id={countryID} className="country-selector--dropdown-container" />
      </React.Fragment>
    </div>
  )
}

export default CountrySelector;
